import { captureError } from '@/assets/js/monitoring'

const CATERING_PURCHASE_EVENT = 'catering_purchase'

const round2 = n => Math.round(n * 100) / 100

// GTM reads this off the data layer and owns the production-host filtering that
// keeps staging and developer pushes out of GA4. A rejected payload is reported
// and dropped: a fabricated zero would train Ads on a conversion that never
// happened.
export function pushCateringPurchase({ orderId, value, tax, shipping }) {
  try {
    if (typeof orderId !== 'string' || !orderId.trim()) {
      captureError(new Error(`${CATERING_PURCHASE_EVENT} skipped: missing or invalid order ID`))
      return
    }
    for (const [field, amount] of Object.entries({ value, tax, shipping })) {
      if (typeof amount !== 'number' || !Number.isFinite(amount) || amount < 0) {
        captureError(new Error(`${CATERING_PURCHASE_EVENT} skipped: invalid ${field}`))
        return
      }
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: CATERING_PURCHASE_EVENT,
      ecommerce: {
        transaction_id: orderId,
        value: round2(value),
        currency: 'SGD',
        tax: round2(tax),
        shipping: round2(shipping)
      }
    })
  } catch(e) {
    captureError(e)
  }
}
